import { createThemedComponent } from "@vitalsource/vstui/themes";
import { Button } from "@vitalsource/vstui";

const PillButton = createThemedComponent(Button, props => ({
  Button_borderRadius:
    props.size === "small"
      ? "1.6rem"
      : props.size === "large"
      ? "2rem"
      : "2.4rem"
}));

export default PillButton;
